import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import store from './store';
import { routesSection } from './routes/sections';

// The data router can block Back/Forward as well as links while a draft is dirty.
const router = createBrowserRouter(routesSection, { future: { v7_relativeSplatPath: true } });

function App() {
  return (
    <Provider store={store}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </Provider>
  );
}

export default App;
